import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumExternalCalendarProvider implements BaseEnumType {
  private static allValues: EnumExternalCalendarProvider[] = []; // make sure this is top-most
  
  public static none = new EnumExternalCalendarProvider(0, "None", "enum_external_calendar_provider_none");
  public static google = new EnumExternalCalendarProvider(1, "Google", "enum_external_calendar_provider_google");
  public static microsoft = new EnumExternalCalendarProvider(2, "Microsoft", "enum_external_calendar_provider_microsoft");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumExternalCalendarProvider.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumExternalCalendarProvider.none; }
  public isGoogle() { return this === EnumExternalCalendarProvider.google; }
  public isMicrosoft() { return this === EnumExternalCalendarProvider.microsoft; }

  public static getValues(): readonly EnumExternalCalendarProvider[] {
    return EnumExternalCalendarProvider.allValues;
  }

  public static getValuesExcept0(): readonly EnumExternalCalendarProvider[] {
    return EnumExternalCalendarProvider.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumExternalCalendarProvider {
    const found = EnumExternalCalendarProvider.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumExternalCalendarProvider - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumExternalCalendarProvider): EnumExternalCalendarProvider {
    const found = name ? EnumExternalCalendarProvider.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumExternalCalendarProvider - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumExternalCalendarProvider>): boolean {
    return this.key === other?.key;
  }
}